import React, { useState } from "react";
import ChatWidget from "./ChatWidget";
import { FaComments } from "react-icons/fa";
import "./ChatButton.css";

const ChatButton = () => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <>
            <button className="chat-button" onClick={() => setIsOpen(!isOpen)}>
                <FaComments />
            </button>
            {isOpen && <ChatWidget onClose={() => setIsOpen(false)} />}
        </>
    );
};

export default ChatButton;
